import { DeleteKomaModel } from '../vo/delete-koma.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 全コマ情報削除コマンド
 *
 * @export
 * @class DeleteAllKomaService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class DeleteAllKomaService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private vo: DeleteKomaModel = null;
  private successFunction: Function = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteKomaService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        CoopCode: this.vo.coopCode,
        PageNum: this.vo.pageNum,
        PageID: this.vo.pageID,
        OrderGoodsFlg: this.vo.orderGoodsFlg
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {DeleteKomaModel} vo パラメータ
   * @param {Function} successFunction 成功時後続処理
   * @memberof DeleteKomaService
   */
  execute(vo: DeleteKomaModel, successFunction: Function) {
    this.vo = vo;
    this.successFunction = successFunction;
    this.send('KYMW14deleteAllKoma', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteKomaService
   */
  success(data: any) {
    this.successFunction();
  }
}
